import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import getStipendi from "../services/getStipendi";
import deleteStipendio from "../services/deleteStipendio";
import moment from "moment";

export default class Stipendi extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
        isLoading: true
    };

  }

  async reload() {
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.headCells = [
      { id: 'dipendente', numeric: false, disablePadding: true, label: 'Dipendente' },
      { id: 'stipendio_base', numeric: true, disablePadding: false, label: 'Stipendio' },
      { id: 'somma_annua', numeric: false, disablePadding: false, label: 'Totale' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    var dates = [];
    var stipendioAnnuale = 0.0;
    var stipendiMensiliSomma = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];

    let currDate = '01/01/' + moment().format('yyyy');
    let endDate = '01/01/' + moment().add(1, 'year').format('yyyy');

    while (currDate.substring(currDate.length, 6) !== endDate.substring(endDate.length, 6)) {
      let data = moment(currDate, 'DD/MM/yyyy').format('MMMM yy');
      dates.push({ id: data.replace(' ', '_'), numeric: false, disablePadding: false, label: data });
      currDate = moment(currDate, 'DD/MM/yyyy').add(1, 'month').format('DD/MM/yyyy');
    }
    
    this.stipendi = await getStipendi(username, token);
    this.stipendi.forEach((s, i) => {
        this.stipendi[i].stipendio_base = this.stipendi[i].stipendio_base + ' €/mese';
        
        var stipendioAnnuo = 0.0;
        var custom = this.stipendi[i].stipendio_custom;
        custom = custom ? JSON.parse(custom) : [];
        if (!custom)
          return;

        custom.forEach(c => {
          if (c[0] !== moment().format('yyyy'))
            return;

          var splicedCustom = c;
          splicedCustom = splicedCustom.slice(1);
          
          splicedCustom.forEach(spl => {
            var data = spl.data;
            data = moment(data, 'DD/MM/yyyy').format('MMMM yy');
            this.stipendi[i][data.replace(' ', '_')] = spl.importo;

            var importoFloat = spl.importo.replace(/\./g, '').replace(/,/g, '.');
            if (!importoFloat) return;
            importoFloat = parseFloat(importoFloat);
            stipendioAnnuo += importoFloat;

            var mese = parseInt(moment(spl.data, 'DD/MM/yyyy').format('MM')) - 1;
            stipendiMensiliSomma[mese] += importoFloat;
          });

          stipendioAnnuale += stipendioAnnuo;

          var t = String(stipendioAnnuo);
          if(/[^0-9,]+/.test(t)) {
              t = t.replace(/[^0-9]+/g, '');
          }
          var chunks = t.split(',');
          chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          t = chunks.join(',');

          this.stipendi[i].somma_annua = t + ' €';
        });
    });

    var t = String(stipendioAnnuale);
    if(/[^0-9,]+/.test(t)) {
        t = t.replace(/[^0-9]+/g, '');
    }
    var chunks = t.split(',');
    chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    t = chunks.join(',');

    var finalStipendio = {
      'dipendente': 'Totale', 
      'stipendio_base': '-', 
      'somma_annua': t + ' €', 
    };

    dates.forEach((d, i) => {

      let importo = stipendiMensiliSomma[i];
      var t = String(importo);
          if(/[^0-9,]+/.test(t)) {
              t = t.replace(/[^0-9]+/g, '');
          }
          var chunks = t.split(',');
          chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          t = chunks.join(',');

      finalStipendio[d.label.replace(' ', '_')] = t;
    });

    this.stipendi.push (finalStipendio);

    this.headCells = [
      ...this.headCells, 
      ...dates,
      { id: '_', numeric: true, disablePadding: false, label: '' }
    ]

    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();
  }


  render () {

    if (this.state.isLoading)
        return <Loading />;

    const cookies = new Cookies();
    this.searchCols = ['dipendente'];

    let finalTable = this.stipendi.pop();

    return (
      <div id={Math.random()}>
        <PageTitle title="Stipendi" button="AGGIUNGI" onClick={() => {
          window.location.href = '/#/app/addStipendio';
        }}/>

        <Table headCells={this.headCells} searchCols={this.searchCols} rows={this.stipendi} total={finalTable}
          onEventClick={(row) => {
          if (!row) return;

          cookies.set('stipendio', row, { path: '/' });
          window.location.href = '/#/app/editStipendio';
        }}

        onDelete={async (id) => {
          if (window.confirm("Sei sicuro di voler eliminare questo stipendio?") == false) return;

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });

          await deleteStipendio(username, token, id);
          this.reload();
        }}

        />
      </div>
    );
  }
}

